/**
 |-----------------------------------------------------------------------------
 | vendor/infinite-scroll.js
 | v1.0.0
 |-----------------------------------------------------------------------------
 |
 | Some description...
 |
 */

/*
 |
 | Some description...
 |
 */

const InfiniteScroll = require('infinite-scroll');





/*
 |
 | Some description...
 |
 */

if ($('.js-infinite-scroll--articles').length > 0) {

	const events = document.querySelector('.js-infinite-scroll--articles');
	const infScroll = new InfiniteScroll(events, {

		// Initialisation
		append: '.c-article',
		hideNav: '.js-pagination',
		history: 'push',
		path: '.js-pagination',
		status: '.c-pagination__status'

	});

}
